import { useState } from "react";

/**
 * Lightweight form stub for /demo/* routes — visually mimics JoinFormSection
 * but does NOT call any API or depend on WeddingProvider context.
 * Submitting just shows a confirmation message.
 */
export function DemoFormStub() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("+90");
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div className="text-center space-y-4 py-8">
        <div className="mx-auto w-16 h-16 rounded-full border-2 border-current flex items-center justify-center">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-xl font-serif font-light">Demo — Kayıt simülasyonu</p>
        <p className="text-sm opacity-50">Gerçek kayıt için ana site üzerinden ilerleyin.</p>
        <button
          onClick={() => { setSubmitted(false); setName(""); setPhone("+90"); }}
          className="text-xs tracking-widest uppercase opacity-50 hover:opacity-100 underline underline-offset-4"
        >
          Tekrar Dene
        </button>
      </div>
    );
  }

  return (
    <form
      onSubmit={(e) => { e.preventDefault(); if (name.trim() && phone.length >= 13) setSubmitted(true); }}
      className="space-y-4"
    >
      <div>
        <label className="block text-xs tracking-widest uppercase mb-2 opacity-60">Adınız</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Adınızı giriniz"
          required
          className="w-full bg-transparent border-b border-current/30 focus:border-current outline-none py-3 text-base placeholder:opacity-40"
        />
      </div>
      <div>
        <label className="block text-xs tracking-widest uppercase mb-2 opacity-60">Telefon</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+90 555 123 4567"
          required
          className="w-full bg-transparent border-b border-current/30 focus:border-current outline-none py-3 text-base placeholder:opacity-40"
        />
      </div>
      <button
        type="submit"
        className="mt-8 w-full py-4 border border-current hover:bg-current hover:text-black transition-colors uppercase tracking-widest text-xs font-medium cursor-pointer"
      >
        Katılımı Onayla
      </button>
      <p className="text-center text-[10px] tracking-wider opacity-40 mt-4">
        Bu bir demo — gerçek kayıt için ana site
      </p>
    </form>
  );
}
